"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INBOUND_ACTIONS = exports.REGION_TYPE = exports.CURRENCY_TYPE = exports.CURRENCY = exports.LANGUAGE_TYPE = exports.EVENT_TYPE = exports.TICKET_ATTENDEE_TYPE = exports.TICKET_VISIBILITY = exports.BOOLEAN_TYPE = void 0;
exports.BOOLEAN_TYPE = [0, 1];
exports.TICKET_VISIBILITY = ["public", "private", "event"];
exports.TICKET_ATTENDEE_TYPE = ["sp", "del", "ex"];
exports.EVENT_TYPE = ["hybrid", "virtual", "onsite"];
exports.LANGUAGE_TYPE = ["de", "en"];
exports.CURRENCY = {
    EUR: "EUR",
    USD: "USD",
};
exports.CURRENCY_TYPE = [exports.CURRENCY.EUR, exports.CURRENCY.USD];
exports.REGION_TYPE = ["asia", "europe", "usa"];
exports.INBOUND_ACTIONS = {
    DOWNLOAD_ATTENDEE_LIST: "download_attendee_list",
    DOWNLOAD_WHITE_PAPER: "download_whitepaper",
    DOWNLOAD_MEDIA_PACKAGE: "download_mediapackage",
    DOWNLOAD_AGENDA: "download_agenda",
    WEBAPP_PARTNER: "webapp_partner",
    WEBAPP_SPEAKER: "webapp_speaker",
    WEBAPP_FREE_TICKET_ONSITE: "webapp_freeticket_onsite",
    VIDEO_CONTENT: "video_content",
    TRIAL_ACCOUNT: "trial_account",
    NEWSLETTER: "newsletter",
    INQUIRY: "inquiry",
    CONTACT_FORM: "contact_form",
    SURVEY_MONKEY: "survey_monkey",
    PODCAST_CONTENT: "podcast_content",
    PAGE_VIEW: "page_view",
    DOWNLOAD_BP_PACKAGES: "download_bp_packages",
};
